import DeviceReducer from "./DeviceReducer";

import { combineReducers } from "redux";
import DeviceTypeReducer from "./DeviceTypeReducer";

export default combineReducers({
    device: DeviceReducer,
    type: DeviceTypeReducer
});